import { Icon } from '@iconify/react'

import styles from '../../ProjectStoryMapBoard.module.css'

const ReleasesEmptyState = ({ onAddRelease, readOnly = false }) => (
    <div className={styles.releasesEmptyState}>
        {!readOnly ? (
            <button
                type="button"
                className={styles.addReleaseEmptyBtn}
                onClick={() => onAddRelease(-1)}
            >
                <Icon icon="mdi:plus" width={14} />
                ADD RELEASE
            </button>
        ) : (
            <p className={styles.noStepStoryMsg}>No releases yet.</p>
        )}
    </div>
)

export default ReleasesEmptyState
